import { useState } from 'react';
import { Base64ImageFileModel, Base64ImageZipRequestBody, AudienceStatsFilterv1 } from 'modules/insights';
import { insightsApi } from 'api/instances';
import { FileDownloader } from 'utils/fileDownloader';
import { getReportFileName } from 'utils/analyticsHelpers';
import { store } from 'configureStore';
import { ScreenShotDownloadService } from 'modules/insights/components/services/screenShotDownloadService';

export const useImageReportDownload = (reportFilter: Partial<AudienceStatsFilterv1>, reportTypes: string[]) => {
    const [isLoadingImage, setIsLoadingImage] = useState(false);

    const downloadSingleImage = async (reportType: string, padding: number = 0) => {
        setIsLoadingImage(true);
        try {
            await ScreenShotDownloadService.downloadSingleImage(reportType, reportFilter, padding);
        } catch (error) {
        } finally {
            setIsLoadingImage(false);
        }
    };

    const downloadAllImages = async (reportType: string, padding: number = 0) => {
        setIsLoadingImage(true);
        try {
            const imageData = await Promise.all(
                reportTypes.map(type => ScreenShotDownloadService.fetchDataAsImage(type, padding))
            );

            const base64ImageFiles: Base64ImageFileModel[] = imageData
                .map((data, index) => data ? {
                    fileName: `${getReportFileName(reportTypes[index])}.png`,
                    base64String: data,
                } : null)
                .filter(Boolean) as Base64ImageFileModel[];

            const zipRequestBody: Base64ImageZipRequestBody = {
                fileName: ScreenShotDownloadService.assembleReportFileName(reportFilter, reportType),
                base64ImageFiles,
            };

            const file = {
                name: ScreenShotDownloadService.assembleReportFileName(reportFilter, reportType),
                type: "application/x-zip-compressed",
            };

            const data = await insightsApi.DownloadInsightReport(
                store.getState().config.downloadAllAudienceReportAsImage, 
                zipRequestBody
            );
            
            new FileDownloader(file).downloadBlob(data);
        } catch (error) {
        } finally {
            setIsLoadingImage(false);
        }
    };

    return {
        isLoadingImage,
        downloadSingleImage,
        downloadAllImages
    };
};